export enum BulkOperationSourceEnum {
  EXPORT = 'EXPORT',
  UPDATE = 'UPDATE'
}
